import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { concat, Observable, of, Subject, throwError } from 'rxjs';
import { GeocodingService } from '../../services/geocoding.service';
import { catchError, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { VerifyService } from 'src/app/services/verify.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoModalComponent } from '../modals/info-modal/info-modal.component';

@Component({
  selector: 'app-account-verification',
  templateUrl: './account-verification.component.html',
  styleUrls: ['./account-verification.component.scss'],
})
export class AccountVerificationComponent implements OnInit {

  token: string;
  tokenId: string;
  isProcessing: boolean = true;
  processText: string = "Account Verifying";

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private verifyService: VerifyService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {

    const lng = this.translate.currentLang;

    this.route.queryParams.subscribe(params => {
      this.token = decodeURIComponent(params['token']);
      this.tokenId = decodeURIComponent(params['token_id']);

      this.verifyService.verifyAccount(this.token, this.tokenId, lng).pipe(
        catchError(err => {
          console.log('Handling error locally and rethrowing it...', err);
          return throwError(err);
        })
      )
        .subscribe(
          res => {
            this.isProcessing = false;

            const infoDlg = this.modalService.open(InfoModalComponent);
            infoDlg.componentInstance.data = {
              text: 'Account is verified successfully',
              header: 'Success'
            };
            const currentLang = localStorage.getItem('user_lng')
            localStorage.clear();
            localStorage.setItem('user_lng',currentLang)
            localStorage.setItem('token_info', JSON.stringify(res));
            
            infoDlg.result.then(() => this.router.navigate(['/', 'help']));
          },
          err => {
            this.isProcessing = false;
            if ([400, 403].includes(err.status)) {
              const infoDlg = this.modalService.open(InfoModalComponent);
              infoDlg.componentInstance.data = {
                text: err.error && err.error.error && err.error.error || 'Invalid or expired verification token.',
                header: err.status === 403 ? 'Failure!' : 'Verification error'
              };
              infoDlg.result.then(() => this.router.navigate(['/login']));
            }
          }
        );
    });
  }
}
